<div class="table-control-panel">
    <ngx-density-controls *ngIf="allowDensityChange"
                          [defaultDensity]="defaultDensity"
                          (densityChanged)="onDensityChanged($event)"></ngx-density-controls>
</div>
